<template>
    <div id="">
        <v-navigation-drawer
          class="gradiente"
          app
          absolute
          temporary
          v-model="showMenu"
          light
        >
          <v-list-item class="px-2 text-center">
            <v-list-item-avatar>
                <img src="@/assets/logo.png" />
            </v-list-item-avatar>
          </v-list-item>
          <v-divider></v-divider>

          <v-list
            dense
            nav
          >
            <v-list-item
              v-for="item in items"
              :key="item.title"
              :to="item.to"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="text-left ml-3">{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <template v-slot:append>
            <div class="pa-2">
              <v-switch
                v-model="dark_theme"
                label="Cambiar tema"
              ></v-switch>
            </div>
          </template>
        </v-navigation-drawer>

        <v-app-bar
          dense
          app
          color="primary"
          hide-on-scroll
        >
          <v-app-bar-nav-icon @click.stop="showMenu = !showMenu"><v-icon>menu</v-icon></v-app-bar-nav-icon>
          <v-toolbar-title>Social Intelligence</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn text @click="logout">
            <span>Cerrar sesión</span>
            <v-icon right>exit_to_app</v-icon>
          </v-btn>
        </v-app-bar>

        <!-- END Page Header -->
        <!-- BEGIN Page Content -->
        <v-main >
          <slot />
        </v-main>
        <!-- END Page Content -->
        <!-- this overlay is activated only when mobile menu is triggered -->
        <div class="page-content-overlay" data-action="toggle" data-class="mobile-nav-on"></div>
        <!-- BEGIN Page Footer -->
        <footer class="page-footer" role="contentinfo">
            <div class="d-flex align-items-center flex-1 text-muted">
                <span class="hidden-md-down fw-700">2019 © Social Intelligence by&nbsp;<a href='https://www.matrix-evolution.com.co' class='text-primary fw-500' title='matrix-evolution.com.co' target='_blank'>matrix-evolution.com.co</a></span>
            </div>
            <div>
                <ul class="list-table m-0">
                    <li><a href="intel_introduction.html" class="text-secondary fw-700">About</a></li>
                    <li class="pl-3"><a href="info_app_licensing.html" class="text-secondary fw-700">License</a></li>
                    <li class="pl-3"><a href="info_app_docs.html" class="text-secondary fw-700">Documentation</a></li>
                    <li class="pl-3 fs-xl"><a href="https://wrapbootstrap.com/user/MyOrange" class="text-secondary" target="_blank"><i class="fal fa-question-circle" aria-hidden="true"></i></a></li>
                </ul>
            </div>
        </footer>
    </div>
</template>

<script>
import apiLogin from '@/api/modules/login';
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    dark_theme: {
      get() {
        return this.$store.state.theme.dark_theme
      },
      set() {
        this.setTheme()
      }
    },
    ...mapGetters({
      token:'auth/authentication'
    })
  },
    mounted(){
        apiLogin.apiVerifyToken(this.token)
        .then((resp)=>{
            if(!resp.data.status){
                this.$router.push('/login');
            }
        })
        .catch(()=>{
            this.$router.push('/login');
        })
    },
    data() {
      return {
        showMenu:false,
        items:[
          {icon: 'dashboard', title: 'Dashboard', to: '/'},
          // {icon: 'analytics', title: 'Analisis Twitter', to: '/analisis_tweeter'},
          {icon: 'favorite_border', title: 'Sentimientos Twitter', to: '/sentimientos_tweeter'},
          // {icon: 'web', title: 'Analisis Website', to: '/analisis_website'},
          // {icon: 'favorite', title: 'Sentimientos Website', to: '/sentimientos_website'},
          {icon: 'date_range', title: 'Procesos', to: '/processes'},
          // {icon: 'pageview', title: 'Extracciones', to: '/tweeter'},
        ]
      }
    },
    methods: {
      logout() {
        this.$cookies.remove('token');
        apiLogin.logout();
        this.$router.push('/login')
      },
      ...mapActions({
        setTheme: 'theme/setTheme'
      })
    }
}
</script>
<style>
  .gradiente{
    background-image: linear-gradient(#CECBD4, #dddae4);
  }
</style>
